import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-solution',
  templateUrl: './develop-challenge-solution.component.html',
  styleUrls: ['./develop-challenge-solution.component.scss']
})
export class DevelopChallengeSolutionComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.developChallengeComponent?.strengthen_content || '';
    this.aiService.openSidebar(
      'develop', 'solution', context,
      'Generate 5 solution statements {persona} to strengthen the approach. Current context: {context}',
      'strengthen_content', this.developChallengeComponent
    );
  }
}
